import { c as _c } from "react/compiler-runtime";
import { ThumbnailGenerator } from "@sticker-giant/sg-frontend-common";
import { IconCircleXFilled } from "@tabler/icons-react";
import { ImagePreviewDialog } from "@/components/custom/ImagePreviewDialog";
import { usePdpStore } from "@/stores/usePdpStore";
import LowDpiWarning from "./LowDpiWarning";
interface Props {
  onDelete: () => void;
}
export default function ImageUploadPreview(t0) {
  const $ = _c(27);
  const {
    onDelete
  } = t0;
  const uploadedFileInfo = usePdpStore(_temp);
  if (!uploadedFileInfo) {
    return null;
  }
  const {
    bucket,
    filepath,
    filename
  } = uploadedFileInfo;
  let t1;
  if ($[0] !== bucket || $[1] !== filepath) {
    t1 = ThumbnailGenerator.getUrl(bucket, filepath);
    $[0] = bucket;
    $[1] = filepath;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const thumbnailUrl = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconCircleXFilled size={22} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onDelete) {
    t3 = <button type="button" onClick={onDelete} aria-label="Delete uploaded artwork" className="absolute -right-2 -top-2 cursor-pointer text-muted-foreground hover:text-foreground">{t2}</button>;
    $[4] = onDelete;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `Preview ${filename}`;
  let t5;
  if ($[6] !== thumbnailUrl) {
    t5 = <img src={thumbnailUrl} alt="" className="max-h-[120px] max-w-[120px] rounded object-contain" />;
    $[6] = thumbnailUrl;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <button type="button" aria-label={t4} className="flex max-h-[120px] w-[120px] shrink-0 cursor-pointer items-center justify-center rounded">{t5}</button>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== bucket || $[12] !== filename || $[13] !== filepath || $[14] !== t6) {
    t7 = <ImagePreviewDialog bucket={bucket} filepath={filepath} title={filename}>{t6}</ImagePreviewDialog>;
    $[11] = bucket;
    $[12] = filename;
    $[13] = filepath;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== filename) {
    t8 = <p className="min-w-0 flex-1 break-all text-sm font-medium leading-snug text-foreground line-clamp-4">{filename}</p>;
    $[16] = filename;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className="flex items-center gap-3">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t9) {
    t10 = <div className="relative rounded-lg border border-input bg-background p-3">{t3}{t9}</div>;
    $[21] = t3;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <LowDpiWarning />;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10) {
    t12 = <div className="flex flex-col gap-2">{t10}{t11}</div>;
    $[25] = t10;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function _temp(s) {
  return s.uploadedFileInfo;
}